<template>
  <div class="header">
    <div class="time">
      <img class="img" src="../assets/Menu.png" alt="" />
      <div class="header_title">
        办公时间：周一至周五&nbsp;&nbsp;&nbsp;8:30-12:00
        14:00-18:00&nbsp;&nbsp;&nbsp;&nbsp;客服电话：400-003-1733
      </div>
      <div style="display: flex;align-items: center;cursor: pointer;margin-left: 30px;" @click="book">
        <div style="width: 40px;height: 40px;">
        <img style="width: 100%;" src="@/assets/home/业务手册.png" alt="">
        </div>
      <a style="text-decoration:underline;font-size: 17PX;font-weight: bold;color: #004eaa;margin-left: 5px;">操作手册</a>
      </div>
    </div>
    <div class="header-right">
        <el-dropdown>
          <div class="header_title">{{ username }}</div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="loginout" @click.native="quit">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      username: "退出登录",
    };
  },
  methods: {
    quit(){
      this.$router.push('/login')
      sessionStorage.clear()
    },
    book() { 
      window.open('https://ejlb673kl8.feishu.cn/wiki/wikcndUsPWQ7ESlpsZATkpM9yUb','_blank')
    }
  },
  created() {
    this.username = sessionStorage.getItem("username");
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.header {
  font-family: none;
  position: relative;
  width: calc(100% - 250PX);
  left: 250PX;
  height: 64PX;
  display: flex;
  justify-content: space-between;
}
.header_title {
  color: black;
	font-size: 17PX;
  font-weight: bold;
}
.time {
  display: flex;
  align-items: center;
	.img{
		width: 21PX;
		margin: 0 20PX;
	}
}

 .header-right {
  padding-right: 50PX;
	line-height: 64PX;
	cursor: pointer;
} 
</style>
